import api from './api';
import { PermissionRequest, RequestableRole } from '../types/models';

export async function submitPermissionRequest(
  targetRole: RequestableRole,
  reason: string,
  yogaAllianceUrl?: string,
): Promise<void> {
  await api.post('/permission-requests', { targetRole, reason, ...(yogaAllianceUrl ? { yogaAllianceUrl } : {}) });
}

export async function getMyPendingRequests(): Promise<PermissionRequest[]> {
  const res = await api.get('/permission-requests/me');
  return res.data.requests;
}

export async function listAdminPendingRequests(): Promise<PermissionRequest[]> {
  const res = await api.get('/admin/permission-requests');
  return res.data.requests;
}

export async function resolvePermissionRequest(
  requestId: string,
  action: 'approve' | 'deny',
): Promise<void> {
  await api.put(`/admin/permission-requests/${requestId}`, { action });
}
